<template>
  <div class="card-box">

    <div class="row">
      <!-- Items per page -->
      <div class="col-sm-12 col-md-6 d-flex align-items-center">
        <div class="mr-2 mb-2">Mostrar&nbsp;</div>
        <div class="mr-2 mb-2 p-0">
          <b-form-select
            v-model="perPage"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </div>
        <div class="mr-2 mb-2 p-0">&nbsp;por página</div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6 d-flex justify-content-end align-items-center">
        <div id="tickets-table_filter"
             class="dataTables_filter text-md-right"
        >
          <b-form-input
            v-model="filter"
            type="search"
            placeholder="Pesquisar..."
            class="form-control form-control-sm mb-2"
          ></b-form-input>
        </div>
      </div>
      <!-- Currency Filter -->
      <!-- <div class="col-sm-12 col-md-3 d-flex justify-content-end align-items-center">
        <div>
          <b-form-select
            v-model="selectedCurrency"
            size="sm"
            class="mb-2"
            name="selectedCurrency"
            @change="updateCoin"
          >
            <b-form-select-option :value="null">Todas moedas</b-form-select-option>
            <b-form-select-option v-for="currency in coins" :key="currency.id"
              :value="currency"
            >
              {{ currency.name }}
            </b-form-select-option>
          </b-form-select>
        </div>
      </div> -->
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div v-if="products.length > 0 && !loading" class="table-responsive mb-0">
          <b-table
            :items="products"
            :fields="fields"
            responsive="sm"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            sort-icon-left
            :filter-included-fields="filterOn"
          >
            <!-- Seller -->
            <template v-slot:cell(_seller)="data">
              <div class="externclass">
                <div class="classification" :style="setColor(data.item.seller.classification)"></div>
                <p>{{ data.item.seller.name }}</p>
              </div>
              <b v-if="data.item.seller.cpf_cnpj">{{ data.item.seller.cpf_cnpj }}</b>
              <div v-if="data.item.seller.cellphone">
                <a
                  :href="`https://api.whatsapp.com/send?phone=+55${data.item.seller.cellphone.replace(/[() -]/g,'')}`"
                  target="_blank"
                >
                  <i class="fab fa-whatsapp"></i> {{ data.item.seller.cellphone }}
                </a>
              </div>
              <div>{{ data.item.seller.email }}</div>
              <NewProgressBar v-if="data.item.seller.score && data.item.seller.score.total_score" :type="'SellerScore'"
                              :valor="data.item.seller.score.total_score"/>
            </template>

            <!-- Name -->
            <template v-slot:cell(name)="data">
              <div v-if="data.item && data.item.is_first_product"
                   class="bg-success rounded flagFirstProduct  text-center text-white">PRIMEIRO PRODUTO
              </div>
              {{ data.item.name }}
            </template>

            <!-- Amount -->
            <template v-slot:cell(amount)="data">
              <span v-if="data.item.offers">
                <template v-if="data.item.offers[0].local_currency !== null">
                  {{ data.item.offers[0].local_currency.currency_symbol }} {{ formatMoney(data.value) }}
                </template>
              </span>
            </template>
            <!-- Type -->
            <template v-slot:cell(type)="data">
              {{
                data.value === 'TRANSACTION'
                  ? 'Valor único'
                  : 'Assinatura'
              }}
            </template>
            <!-- Local Currency -->
            <template v-slot:cell(currency)="data">
              <span v-if="data.item.offers">
                <template v-if="data.item.offers[0].local_currency !== null">
                  {{ data.item.offers[0].local_currency.name }}
                </template>
              </span>
            </template>
            <!-- Creation Date  -->
            <template v-slot:cell(created_at)="data">
              {{ data.value | datetime }}
            </template>
            <!-- Actions -->
            <template v-slot:cell(_actions)="data">
              <div v-if="!attendance && !success" class="actions">
                <!-- Approve Product -->
                <b-button
                  v-if="canShowApproveButton"
                  v-b-tooltip.hover title="Aprovar produto"
                  variant="success"
                  @click="accept([data.item.id, data.item.format])"
                >
                  <i class="fas fa-check"></i>
                </b-button>
                <!-- Disapprove  Product -->
                <b-button
                  v-if="canShowDisapproveButton"
                  v-b-tooltip.hover title="Reprovar produto"
                  variant="danger"
                  @click="deny([data.item.id, data.item.format])"
                >
                  <i class="fas fa-times"></i>
                </b-button>
                <!-- Info User and Product -->
                <b-button
                  v-b-tooltip.hover title="Informações do usuário e do produto"
                  :disabled="!canViewProductDetails"
                  variant="dark"
                  @click="detail(data.item)"
                >
                  <i class="fas fa-info-circle"></i>
                </b-button>
                <!-- Login -->
                <b-button
                  v-if="canShowLogin"
                  v-b-tooltip.hover title="Fazer login"
                  variant="info"
                  @click="login(data.item.seller.id)"
                >
                  <i class="fas fa-sign-in-alt"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <!--Pagination -->
    <div v-if="products.length > 0" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <!-- Feedback Menssage -->
    <div v-if="products.length === 0 && !loading"
         class="row justify-content-center"
    >
      <div class="alert alert-primary" role="alert">
        Sem produtos pendentes.
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import ProductService from '@services/resources/ProductService'
import Money from '@src/mixins/money'
import Access from '@src/mixins/access'
import _ from 'lodash'
import Graph from '@router/views/analysis/graph.vue';
import validAcessRoute from '@/src/utils/validAcessRoute'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import FoundSearchMixin from "@views/products/mixins/FoundSearchMixin";
import {AccessLevel} from "@views/configurations/enums/accessLevel";

var service = ProductService.build()

export default {
  name: "TableProductsForApproval",
  components: {Graph, NewProgressBar},
  mixins: [Money, Access, FoundSearchMixin],
  props: {
    modalAcceptForApproval: {
      required: true,
      type: Boolean,
      default: false
    },
    modalDenyForApproval: {
      required: true,
      type: Boolean,
      default: false
    },
    coins: {
      required: true,
      type: Array,
      default: () => []
    },
    activeTab: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      currentPage: 1,
      dataUser: {},
      loading: true,
      productsLoaded: false,
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: '_seller', label: 'Vendedor', sortable: true},
        {key: 'name', label: 'Produto', sortable: false},
        {key: 'amount', label: 'Valor', sortable: true},
        {key: 'type', label: 'Tipo', sortable: false},
        {key: 'currency', label: 'Moeda Local', sortable: false},
        {key: 'created_at', label: 'Data de Criação', sortable: false},
        {key: '_actions', label: 'Ações', sortable: false},
      ],
      filter: '',
      filterOn: [],
      filters: {},
      products: [],
      pageOptions: [20, 50, 100],
      perPage: 20,
      selectedCurrency: null,
      sortBy: 'name',
      sortDesc: false,
      totalRows: 1,
      total: 0,
      // Actions Validations
      financial: validAcessRoute(['financial'], this.$store.getters.getProfile),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      attendance: validAcessRoute(['attendance'], this.$store.getters.getProfile),
      success: validAcessRoute(['success'], this.$store.getters.getProfile),
      financialManager: validAcessRoute(['financialManager'], this.$store.getters.getProfile),
      financialAssistant: validAcessRoute(['financialAssistant'], this.$store.getters.getProfile),
      compliance: validAcessRoute(['compliance'], this.$store.getters.getProfile)

    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canApproveProduct() {
      return (!this.financial && !this.risco && !this.financialAssistant) || this.financialManager || this.compliance;
    },
    canShowApproveButton() {
      if(this.useActionPermissions) {
        return this.$canAction('products_approve_button', AccessLevel.EDITOR);
      }
      
      return this.canApproveProduct;
    },
    canShowDisapproveButton() {
      if(this.useActionPermissions) {
        return this.$canAction('products_disapprove_button', AccessLevel.EDITOR);
      }
      
      return this.canApproveProduct;
    },
    canShowLogin() {
      if (this.useActionPermissions) {
        return this.$canAction('products_approve_button', AccessLevel.EDITOR)
      }

      return !this.financialAssistant && !this.risco || this.compliance
    },
    canViewProductDetails() {
      if (this.useActionPermissions) {
        return this.$canAction('products_show_details', AccessLevel.READER);
      }
      // In the old system, everyone with access to the screen can view details
      return true;
    },
  },
  watch: {
    currentPage() {
      this.fetchProducts()
    },
    perPage() {
      this.fetchProducts()
    },
    filter() {
      this.debounce()
    },
    modalAcceptForApproval() {
      if (this.modalAcceptForApproval) this.accept();
    },
    modalDenyForApproval() {
      if (this.modalDenyForApproval) this.deny();
    },
    activeTab(val) {
      // if tab is active, fetch products
      if (val === 'revisao' && !this.productsLoaded) {
        this.applyFoundSearch()
        this.fetchProducts()
      }
    }
  },
  methods: {
    /**
     * Set color in style dot before seller name on table depending on seller classification
     * @param color - String
     * @return String - css style background color
     * @author Sandro Souza
     */
    setColor(color) {
      if (color) {
        switch (color) {
          case 'green':
            return 'background: #00E4A0'
          case 'yellow':
            return 'background: #fff700'
          case 'red':
            return 'background: #FF0A44'
          case 'black':
            return 'background: #000000'
          default:
            return 'background:#c7c7c7;'
        }
      }
    },
    /**
     * Filter table data
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    debounce: _.debounce(function () {
      this.fetchProducts()
    }, 500),
    /**
     * Brings all products, or only filtered products. It feed the table.
     * @param filters - Object
     * @return no return
     * @author Sandro Souza
     */
    fetchProducts(filters = {}) {
      this.loading = true
      this.products = []
      let currency = this.isHeaven ? 'USD' : 'BRL'
      // let currency = null;
      // if(this.selectedCurrency) currency = this.selectedCurrency.currency

      let data = {
        per_page: this.perPage,
        page: this.currentPage,
        status: 'REVISION',
      };

      if (currency != null) {
        data.currency = currency;
      }

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.filter.length) data.search = this.filter

      service
        .search(data)
        .then((resp) => {
          this.products = resp.data
          this.totalRows = resp.total
          this.total = resp.total
          this.productsLoaded = true
          this.$store.dispatch(
              'updateFoundInStatuses',
              resp.found_in_status || []
          )
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.productsLoaded = false;
          this.loading = false
        });
    },
    /**
     * Fires when user selects a currency. Updates table data by applying currency filter.
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    updateCoin() {
      this.fetchProducts({});
    },
    // Actions Products Approved
    /**
     * Open SweetAlert2 to approve product
     * @param dados - Array - ex: [4046,"INFOPRODUCT"]
     * @return no return
     * @author Sandro Souza
     */
    accept(dados) {
      Vue.swal({
        title: 'Aprovar produto',
        text: 'Tem certeza que deseja aprovar esse produto pendente?',
        type: 'warning',
        input: 'checkbox',
        inputValue: 1,
        inputPlaceholder: 'Será mostrado na vitrine caso o produtor desejar',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          let data = {
            id: dados[0],
            format: dados[1],
            status: 'APPROVED',
            is_public_allowed: result.value === 1,
          }
          service
            .update(data)
            .then((resp) => {
              this.$bvModal.hide('details')
              this.fetchProducts()
            })
            .catch(err => console.error(err))
        }
      })
      this.$emit('update-accept-for-approval')
    },
    /**
     * Open SweetAlert2 to refuse product
     * @param dados - Array - ex: [4046,"INFOPRODUCT"]
     * @return no return
     * @author Sandro Souza
     */
    deny(dados) {
      Vue.swal({
        title: 'Reprovar produto',
        text: 'Tem certeza que deseja Reprovar esse produto?',
        type: 'warning',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Reprovar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: dados[0],
            format: dados[1],
            status: 'DISAPPROVED',
            pending_motive: result.value,
          }

          service
            .update(data)
            .then((resp) => {
              this.$bvModal.hide('details')
              this.fetchProducts()
            })
            .catch(err => console.error(err))
        }
      })
      this.$emit('update-deny-for-approval')
    },
    /**
     * Open details modal. Send "dataUser" for parent component (./list.vue) that imported details modal.
     * @param dataUser - Object
     * @return no return
     * @author Sandro Souza
     */
    detail(dataUser) {
      this.$emit('open-detail', dataUser.id)
    },
    /**
     * Redirects user to another tab in browser to login to adm.
     * @param id - Number
     * @return no return
     * @author Sandro Souza
     */
    login(id) {
      let url = (this.isHeaven ? process.env.VUE_APP_HEAVEN_ADM_PAGE : process.env.VUE_APP_ADM_PAGE) + '/admin-login/' + btoa(id)
      window.open(url)
    }
    // -----------------------------
  },
}
</script>

<style scoped>
.card-box {
  border-radius: 0 0 3px 3px;
}

.flagFirstProduct {
  font-size: 8px;
  width: 40%;
}
</style>
